module.exports = __webpack_public_path__ + "img/Sign_364.fb339c4f.png";